import { i18n } from '@lt/localization';
import React from 'react';

import { EmptyHotelMap } from '@lt/components/icons-react/map';
import classnames from 'classnames';
import type { EmptyMapProps } from './types';
import { EMPTY_MAP_CONTAINER_TEST_ID } from './constants';

import styles from './emptyMap.module.css';

/*
    Добавил в дефолт высоту, основываясь на том,
    что в случае пустого ответа об отелях
    слева появится контейнер такой же высоты с
    сообщением о том, что туров нет
*/
const defaultProps = {
  title: i18n.t('map.static.message.title'),
  description: i18n.t('map.static.message.ovelay'),
  height: 348,
};

export const EmptyMap = ({
  title = defaultProps.title,
  description = defaultProps.description,
  height = defaultProps.height,
  isMobile = false,
}: EmptyMapProps) => (
  <div
    className={styles.container}
    style={{ height: Number(height) }}
    data-testid={EMPTY_MAP_CONTAINER_TEST_ID}
  >
    <EmptyHotelMap className={styles.emptyHotelMap} />
    <div
      className={classnames(styles.header, { [styles.mobileHeader]: isMobile })}
    >
      {title}
    </div>
    <div className={classnames(styles.text, { [styles.mobileText]: isMobile })}>
      {description}
    </div>
  </div>
);
